export default {
  text: {
    en: 'Order now & receive your delivery asap!<br />Get <strong>25% off</strong> first month',
  },
  subscribe: {
    en: 'Subscribe',
  },
}
